var _circle, _circle2, _path, _ellipse, _ellipse2, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterFaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: 18.5,
    r: 18.5,
    fill: "#05FF00"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.4998,
    cy: 18.4998,
    r: 16.5319,
    stroke: "black",
    strokeWidth: 0.787234
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.3404 18.8936C28.3404 24.1109 24.1109 28.3404 18.8936 28.3404C13.6763 28.3404 9.44678 24.1109 9.44678 18.8936",
    stroke: "black",
    strokeWidth: 0.787234,
    strokeLinecap: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 13.3802,
    cy: 14.1445,
    rx: 1.57166,
    ry: 3.02242,
    fill: "black"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 24.2611,
    cy: 14.1445,
    rx: 1.57166,
    ry: 3.02242,
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6112 11.0215L20.4683 21.2555H17.3193",
    stroke: "black",
    strokeWidth: 0.787234,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterFaceIcon);
export default __webpack_public_path__ + "static/media/footer-face-icon.2e4185cacb4b519d2b54097c1f9240e2.svg";
export { ForwardRef as ReactComponent };